(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-kit-snippet"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.car-kit-section').forEach(section => {
    const buttons = section.querySelectorAll('.car-kit-tabs button');
    const contents = section.querySelectorAll('.car-kit-content');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-tab');
        const targetContent = section.querySelector(`#${targetId}`);

        // Agar same button dobara click hua aur content visible hai → band kar do
        if (btn.classList.contains('active')) {
          btn.classList.remove('active');
          targetContent.style.display = 'none';
          return;
        }

        // Pehle sab hide kar do
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.style.display = 'none');

        // Fir clicked button aur content show karo
        btn.classList.add('active');
        targetContent.style.display = 'block';
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
